import { ChatMessageType, ChatMessagePayload } from "@jugl-web/rest-api";
import {
  ChatCallType,
  ScenarioCallType,
  ChatMessage,
} from "@web-src/modules/chats/types";
import { IAgoraRTCClient } from "agora-rtc-react";
import { createContext } from "react";
import { useActiveCall } from "../hooks/useActiveCall";
import { ActiveCallProps, CallStage } from "../types";

export interface CallsContextType {
  initiateCall?: (chatId: string, type: ChatMessageType) => void;
  joinCall?: (params: {
    channel: string;
    callType?: ChatCallType;
    type?: ScenarioCallType;
    to?: string;
    isIncomingCall?: boolean;
    conferenceMessage?: ChatMessagePayload["conference"];
  }) => void;
  leaveCall?: () => void;
  client?: IAgoraRTCClient;
  activeCall?: ReturnType<typeof useActiveCall>;
  incomingCall?: ChatMessage;
  callMsgId?: string;
  setIncomingCall?: React.Dispatch<
    React.SetStateAction<ChatMessage | undefined>
  >;
  videoDevices?: MediaDeviceInfo[];
  audioDevices?: MediaDeviceInfo[];
  playbackDevices?: MediaDeviceInfo[];
  activeCallProps?: ActiveCallProps;
  callStage?: CallStage;
  setCallStage?: React.Dispatch<React.SetStateAction<CallStage>>;
}

export const CallsContext = createContext<CallsContextType>({});
